module.exports = __webpack_public_path__ + "img/backimg.408d034.webp";